// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"101":"ProductPurchasePage","542":"CompanyProfilePage","718":"ContactPage","727":"HomeOriginPage","786":"BusinessContentPage"}[chunkId] + "." + {"101":"3e92208b","542":"af6177cd","718":"fb4ea935","727":"e4c40312","786":"324a617d"}[chunkId] + ".css";
};